module.exports = __webpack_public_path__ + "img/az.b5b7720b.png";